import { render } from "./footerComponent.vue?vue&type=template&id=60966c20&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"

import "./footerComponent.vue?vue&type=style&index=0&id=60966c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60966c20"]])

export default __exports__